import service from "../libs/request.js";

// 获取盛京TV列表
var getwzTvList = function(postdata, callback) {
  service.get({
    url: "/wzSjTv/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医讯列表
var getwzSjMedicalInformationMenuList = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getMenuList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

//获取盛京医讯列表
var getwzSjMedicalInformationInfo = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getMenuInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医讯
var getwzSjMedicalInformationList = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京映像列表
var getSjImageList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getSjImageList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医院的故事列表
var getSjStoryList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getSjStoryList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医院的故事列表
var getSyHisList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getSyHisList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取百年历史列表
var getHisList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getHisList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取上一个、当前、下一个百年历史图片集
var getThreeInfo = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getThreeInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取院标院训院歌列表
var getSongList = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getSongList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取大道精深 大道精诚
var getMainRoad = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getMainRoad",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取奉天三十年
var getThirtyYears = function(postdata, callback) {
  service.get({
    url: "/wzSjCulture/getThirtyYears",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取奉天三十年
var getInfo = function(postdata, callback) {
  service.get({
    url: "/wzSjMedicalInformation/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getwzTvList,
  getwzSjMedicalInformationMenuList,
  getwzSjMedicalInformationInfo,
  getwzSjMedicalInformationList,
  getSjImageList,
  getSjStoryList,
  getSyHisList,
  getThreeInfo,
  getSongList,
  getMainRoad,
  getThirtyYears,
  getHisList,
  getInfo,
};
